import {ActionType} from "../../model/actionType"
import {errorHandler} from "./auth"

export const getCallDirectory = (filters: any = {}) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({type: ActionType.LOADER, payload: true})
    try {
        const query = Object.entries(filters).filter(([_, v]) => v && `${v}`.length).map(([k, v]) => `${k}=${v}`).join('&');
        const resp = await api.get(`call-recordings/directoryList?${query}`);
        dispatch({type: ActionType.LOAD_CALL_DIRECTORY, payload: {callDirectory: resp}});
        dispatch({type: ActionType.LOADER, payload: false})
        return resp;

    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false})
        return {};
    }
}

export const getCampaigns = () => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({type: ActionType.LOADER, payload: true})
    try {

        const resp = await api.get(`call-recordings/campaigns`);
        dispatch({type: ActionType.LOADER, payload: false})
        return resp;

    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false})
        return []
    }
}

export const fetchCallDates = (practice: string) => async (dispatch: Function, getState: Function, api: any) => {
    const url = `call-recordings/directoryList?practice=${practice}`;
    dispatch({type: ActionType.LOADER, payload: true})
    try {

        const resp = await api.get(url)
        dispatch({type: ActionType.LOAD_CALL_DATES, payload: {callDates: resp}});
        dispatch({type: ActionType.LOADER, payload: false})
        return resp;

    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false})
        return dispatch(errorHandler(err))
    }
}

export const fetchCallRecords = (activePage: number, selectedPageSize: number, practice: string, campaign: string, date: any) => async (dispatch: Function, getState: Function, api: any) => {
    const url = `call-recordings/directoryList?activePage=${activePage}&selectedPageSize=${selectedPageSize}&practice=${practice}&campaign=${campaign}&dateFolder=${date}`;
    dispatch({type: ActionType.LOADER, payload: true})
    try {

        const resp = await api.get(url)
        dispatch({type: ActionType.LOAD_CALL_RECORDINGS, payload: {callRecordings: resp}});
        dispatch({type: ActionType.LOADER, payload: false})
        return resp;

    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false})
        return dispatch(errorHandler(err))
    }
}

export const downloadRecording = (key: string, title: any) => async (dispatch: Function, getState: Function, api: any) => {
    const url = `call-recordings/downloadCallRecording?key=${key}&title=${title}`;
    dispatch({type: ActionType.LOADER, payload: true})
    try {

        const resp = await api.get(url)
        dispatch({type: ActionType.DOWNLOAD_CALL_RECORDING, payload: {url: resp.data}});
        dispatch({type: ActionType.LOADER, payload: false})
        return resp;

    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false})
        return dispatch(errorHandler(err))
    }
}

export const searchByText = (text: string) => async (dispatch: Function, getState: Function, api: any) => {
    const url = `call-recordings/search?text=${text}`;
    dispatch({type: ActionType.LOADER, payload: true})
    try {

        const resp = await api.get(url)
        dispatch({type: ActionType.LOAD_SEARCH_BY_TEXT, payload: {callRecordings: resp}});
        dispatch({type: ActionType.LOADER, payload: false})
        return resp;

    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false})
        return dispatch(errorHandler(err))
    }
}

/**
 * Fetch patient origin report of practices
 * @param params (current date)
 * @returns Patient Origin List
 */

